import React, { PropsWithChildren, useState } from 'react';

import BottomSheet from 'components/DesignSystem/BottomSheet';
import QueryCard from 'components/Meteorology/Shared/QueryCard';
import QueryCardTrigger from 'components/Meteorology/Shared/QueryCard/Trigger';
import SheetActionButton from 'components/Layout/MobileShell/SheetActionButton';

import './index.scss';

/**
 * Painel de controle dos informes que ainda não têm um sheet próprio no mobile (Decomp,
 * Intersemanal, Semanal, Matriz, Mensal): um gatilho no topo que abre um BottomSheet com o
 * **mesmo** painel do desktop (`children`), sem duplicar a lógica de cada informe. Fica sempre
 * montado e o painel só é montado com a folha aberta (o conteúdo do Modal não monta fechado).
 */
export default function PainelSheetGenerico({ children }: PropsWithChildren) {
  const [open, setOpen] = useState(false);

  return (
    <div className="relatorios-painel-generico">
      <QueryCard>
        <QueryCardTrigger onClick={() => setOpen(true)} />
      </QueryCard>

      <BottomSheet
        open={open}
        dismiss={() => setOpen(false)}
        title="Painel de controle"
        className="relatorios-painel-generico-sheet"
      >
        <div className="relatorios-painel-generico-sheet-body">{children}</div>
        <div className="relatorios-painel-generico-sheet-footer">
          <SheetActionButton variant="confirm" onClick={() => setOpen(false)}>
            Concluir
          </SheetActionButton>
        </div>
      </BottomSheet>
    </div>
  );
}
